import { batch } from 'react-redux'
import { toast } from 'react-toastify'
import postDesktopUser from '../../../axios/registration/desktop/post'
import fetchAllUsers from '../../../axios/registration/user'
import deleteUser from '../../../axios/registration/user/delete'
import putDesktopUser from '../../../axios/registration/desktop/put'
import { setAppErrors } from '../../../action/system'
import { retrieveErrorFromApi } from '../../../../helper'
import { setAllDesktopUsers, setDesktopClientJson, setDesktopIsConnecting, setDesktopShowModal } from '../../../action/desktop'
import axios from 'axios'
import { isLocalStorageMobileAppMode } from '../../../../helper/mode'
import { v4 as uuidv4 } from 'uuid'

export const postDesktopUserThunk = (login) => dispatch => {
	return postDesktopUser(login)
		.then(res => {
			batch(() => {
				dispatch(fetchAllDesktopUsersThunk())
				dispatch(setDesktopClientJson(res.data.token))
				dispatch(setDesktopShowModal(true))
			})
		}).catch(error => {
			dispatch(setAppErrors(retrieveErrorFromApi(error)))
		})
}

export const putDesktopUserThunk = (id) => dispatch => {
	return putDesktopUser(id)
		.then(res => {
			if (isLocalStorageMobileAppMode()) {
				dispatch(connectAndroidClientThunk(res.data.token))
			} else {
				dispatch(connectDesktopClientThunk(res.data.token))
			}
		}).catch(error => {
			dispatch(setAppErrors(retrieveErrorFromApi(error)))
		})
}

export const connectDesktopClientThunk = (token) => async (dispatch, getState) => {
	if (!getState().desktop.desktopIsConnecting) {
		dispatch(setDesktopIsConnecting(true))
		await new Promise(resolve => setTimeout(resolve, 1000))
		try {
			await axios.get('http://127.0.0.1:18080/auth?code=' + token)
			toast.success('Desktop client connection success')
		} catch (error) {
			toast.error('Failed to connect desktop client')
		}
		dispatch(setDesktopIsConnecting(false))
	}
}

export const connectAndroidClientThunk = (token) => async (dispatch) => {
	dispatch(setDesktopIsConnecting(true))
	await new Promise((resolve) => setTimeout(resolve, 1000))
	const data = JSON.parse(atob(token))
	const message = {
		eventId: uuidv4(),
		traceId: uuidv4(),
		type: 'kassa-web.ANDROID_CONNECTION_REQUESTED',
		context: 'kassa-web',
		eventTime: new Date().toISOString(),
		data: { authData: { companyIndex: data.companyIndex, login: data.login, password: data.password } },
	}
	if (window.ReactNativeWebView) {
		window.ReactNativeWebView.postMessage(JSON.stringify(message))
	} else {
		toast.error('Failed to connect android client')
		dispatch(setDesktopIsConnecting(false))
	}
}

export const fetchAllDesktopUsersThunk = () => dispatch => {
	return fetchAllUsers('DESKTOP_CLIENT_CONTEXT', null, 0, 20)
		.then(res => {
			batch(() => {
				dispatch(setAllDesktopUsers(res.data))
			})
		}).catch(error => {
			dispatch(setAppErrors(retrieveErrorFromApi(error)))
		})
}

export const deleteDesktopUserThunk = (id) => dispatch => {
	return deleteUser(id)
		.then(res => {
			toast.success('Desktop client deleted')
			dispatch(fetchAllDesktopUsersThunk())
		}).catch(error => {
			dispatch(setAppErrors(retrieveErrorFromApi(error)))
		})
}
